<!-- <footer class="footer">
   <p class="copyright clearfix m-0 text-center">
      Copyright &copy; <a href="https://www.autofacets.com/" class="clrblue">AutoFacets</a>
      <span class="d-none d-sm-inline-block">, All rights reserved.</span> <span class="pipe">|</span> version : 1.0
   </p>
</footer> -->
<footer class="footer mt-auto pb-0 bg-transparent">
   <div class="container">
      <div class="row">
         <div class="col-12 col-md-auto d-flex align-items-center">
            <p class="copyright clearfix m-0">
               &copy;&nbsp;{{currentYear}}&nbsp;<span translate>lblCopyRight</span> <a href="https://www.autofacets.com/" target="_blank" class="font-weight-bold ml-1" rel="noopener"> <u>AutoFacets</u></a>
               <span class="d-none d-sm-inline-block">, <span translate>lblAllRightReserved</span></span> 
              
            </p>
         </div>
         <div class="col-12 col-md-auto ml-auto powered-text d-flex align-items-center">
            <div class="">
               <span translate class="font16">lblPoweredBy </span> 
               <span>
                  <img src="./../../assets/images/afx/header-logo.svg"
                  alt="Logo" height="25" />
               </span>
               
            </div>

         </div>
      </div>
   </div>
</footer>